import { AxiosPromise } from 'axios';
import { instance } from '../../../../services';

const purgeVisitors = (retainDataForInDays: number): AxiosPromise => {
  return instance.delete(`api/gdpr?retainDataForInDays=${retainDataForInDays}`);
};

export default purgeVisitors;
